import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isProcedureValidationContext} from 'procedures/design/validation/procedureValidationUtils';
import {useNullableProcedureFlowchartValidationContext} from 'procedures/processes/useNullableProcedureFlowchartValidationContext';

import {StaticTemplateFlowchart} from './processFlowchartConfigEditorConstants';

export interface ApplicationFlowchartValidationContextResult {
  context: Record<string, unknown>;
  isLoaded: boolean;
}

/**
 * Hook to compute validation context for flowchart validation based on execution type.
 *
 * This hook is platform-agnostic and delegates to application-specific implementations
 * based on the execution type. Application teams should provide their own implementations
 * for their specific execution types.
 *
 * @param executionType The execution type of the flowchart
 * @param draftFlowchartConfig The draft flowchart configuration
 * @returns Validation context object plus readiness flag, or empty object if no application-specific implementation exists
 */
export function useApplicationFlowchartValidationContext(
  executionType: ProcessExecutionType,
  draftFlowchartConfig: StaticTemplateFlowchart
): ApplicationFlowchartValidationContextResult {
  const procedureValidationContext = useNullableProcedureFlowchartValidationContext(draftFlowchartConfig);

  if (executionType === ProcessExecutionType.PROCEDURE) {
    const isLoaded = isProcedureValidationContext(procedureValidationContext);
    return {
      context: procedureValidationContext,
      isLoaded,
    };
  }

  return {
    context: {},
    isLoaded: true,
  };
}
